{
  "decrease": "Samazināšana {fieldLabel}",
  "increase": "Palielināšana {fieldLabel}",
  "numberField": "Skaitļu lauks"
}
